import { Red } from "src/styles/color";

const Danger = ({ size = 24, color = Red }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2558 1.9743C19.9753 0.427478 23.4348 1.44378 24.9545 4.20814L39.4921 30.0853C39.812 30.8577 39.952 31.4858 39.992 32.1383C40.072 33.6627 39.552 35.1445 38.5322 36.2848C37.5124 37.421 36.1326 38.0918 34.6329 38.1731H5.35781C4.73791 38.1345 4.11802 37.9901 3.53811 37.7666C0.638603 36.5673 -0.761161 33.1932 0.41864 30.2682L15.0562 4.18984C15.5561 3.27313 16.316 2.48245 17.2558 1.9743ZM19.9953 26.4246C19.0355 26.4246 18.2356 27.2376 18.2356 28.2153C18.2356 29.1889 19.0355 30.004 19.9953 30.004C20.9552 30.004 21.735 29.1889 21.735 28.193C21.735 27.2193 20.9552 26.4246 19.9953 26.4246ZM19.9953 13.7431C19.0355 13.7431 18.2356 14.5338 18.2356 15.5115V21.2617C18.2356 22.2374 19.0355 23.0525 19.9953 23.0525C20.9552 23.0525 21.735 22.2374 21.735 21.2617V15.5115C21.735 14.5338 20.9552 13.7431 19.9953 13.7431Z"
      fill={Red}
    />
  </svg>
);
export default Danger;
